<button
  mat-icon-button
  [disabled]="disabled"
  (click)="toggle($event)"
  pTooltip="Informações do registro"
  tooltipPosition="top"
  class="info-btn"
  >
  <i
    class="pi pi-info-circle info-icon"
    [matBadge]="temObservacao ? '\u200B' : ''"
    matBadgeSize="small"
    matBadgePosition="above after"
  ></i>
</button>

<p-popover #popover appendTo="body">
  <div class="info-registro-container">
    <div class="info-campo">
      <span class="info-label">Cadastrado por</span>
      <span class="info-valor">{{ info.cadastradoPor }}</span>
    </div>
    <div class="info-campo">
      <span class="info-label">Data de cadastro</span>
      <span class="info-valor">{{ info.dataCadastro | date:'dd/MM/yyyy HH:mm' }}</span>
    </div>
    <div class="info-campo">
      <span class="info-label">Modificado por</span>
      <span class="info-valor">{{ info.modificadoPor ?? '—' }}</span>
    </div>
    <div class="info-campo">
      <span class="info-label">Data de modificação</span>
      <span class="info-valor">{{ info.dataModificacao ? (info.dataModificacao | date:'dd/MM/yyyy HH:mm') : '—' }}</span>
    </div>

    @if (info.observacao !== undefined) {
      <hr class="divider" />
      <div class="info-campo observacao-campo">
        <span class="info-label">Observação</span>
        <textarea
          pTextarea
          [(ngModel)]="observacaoEditada"
          rows="3"
          class="observacao-textarea"
          placeholder="Adicionar observação..."
          [readonly]="disableSalvar"
        ></textarea>
      </div>
      <div class="acoes">
        <p-button label="Salvar" icon="pi pi-check" size="small" [disabled]="disableSalvar" (onClick)="salvar()" />
      </div>
    }
  </div>
</p-popover>
